var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.5C19 14.2239 18.3152 15.8772 17.0962 17.0962C15.8772 18.3152 14.2239 19 12.5 19C10.7761 19 9.12279 18.3152 7.90381 17.0962C6.68482 15.8772 6 14.2239 6 12.5M19 12.5C19 10.7761 18.3152 9.12279 17.0962 7.90381C15.8772 6.68482 14.2239 6 12.5 6C10.7761 6 9.12279 6.68482 7.90381 7.90381C6.68482 9.12279 6 10.7761 6 12.5M19 12.5H6",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5C14.8772 14.877 14.0017 17.1533 12.5 19C10.9983 17.1533 10.1228 14.877 10 12.5C10.1228 10.123 10.9983 7.84665 12.5 6C14.0017 7.84665 14.8772 10.123 15 12.5Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnWeb);
export default __webpack_public_path__ + "static/media/icn_web.7bf4903abefb00ae90e7a04fa823a99a.svg";
export { ForwardRef as ReactComponent };